import { render, staticRenderFns } from "./MaintenanceSetupComponent.vue?vue&type=template&id=3a649d02"
import script from "./MaintenanceSetupComponent.vue?vue&type=script&lang=js"
export * from "./MaintenanceSetupComponent.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceSetupComponent.vue?vue&type=style&index=0&id=3a649d02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports